import * as React from "react"
import styled from "@emotion/styled"
import { theme, rr } from "../../styles/styleGuide"
var color = theme.color,
  font = theme.font

function Quality() {
  return (
    <Container id="quality">
      <Clip className="clip">
        <Content />
        <Border />
      </Clip>
      <HeadBorders className="section-title" />
    </Container>
  )
}
const Container = styled.div`
  position: absolute;
  bottom: 0;
  width: 100vw;
  ${rr("height", "vh", 90)}
  overflow: hidden;
`
const Border = styled.div`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  ${rr("border", ` solid ${color.yellow}`, "2.4vw", "2.4vw", "2.1vw")}
  box-sizing: border-box;
`
const Clip = styled.div`
  height: 100%;
  width: 100vw;
  clip-path: inset(0% 0% 0% 0%);
  background-color: ${color.red};
`
const HeadBorders = styled.div`
  position: absolute;
  top: 0vh;
  height: 5%;
  width: 100vw;
  /* transform: translateY(20vh); */
  background-color: ${color.yellow};
  /* background-color: ${color.black}; */
`
const Content = () => {
  const Figure = styled.span`
    /* position: relative; */
    display: inline-block;
    color: inherit;
    font-size: inherit;
    margin: 0;
    ${font.title};
  `
  const Split = (text: string) => {
    return text.split("").map((e: string, key: number) => (
      <Figure className="figure" key={key}>
        {e}
      </Figure>
    ))
  }
  const Q = styled.span`
    display: inline-block;
    position: absolute;
    transform: translate(-3.6em, 2em) scale(15);
  `
  const Text = styled.span`
    font-size: 28em;
    line-height: 1.2;
    color: ${color.white};
    ${font.title}
  `

  const Uality = styled.span`
    /* bottom: 2.5em;
    right: -0.6em; */
    font-size: 28em;
    line-height: 1;
    ${rr(
      "transform",
      ` translateX(3%)`,
      "translateY(-137%)",
      "translateY(-80%)",
      "translateY(-80%)"
    )}
    overflow: hidden;
    mix-blend-mode: difference;
    color: ${color.yellowInvers};
  `
  const Parts = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    transform: translate(27%, -10%) scale(0.5);
    width: 100vw;
    ${rr("height", "vh", 70)}/* background-color: ${color.red}; */
  `

  const Holder = styled.div`
    position: relative;
    width: 100vw;
    ${rr("font-size", "vw", 1, 1, 0.75)}
    ${rr("top", "vh", 10, 10, 5)}
    ${rr("left", "vw", 0, 7, 12)}
    ${rr("height", "vh", 90)}
    display: flex;
    flex-direction: column;
    align-items: center;
    .yellow {
      color: ${color.yellow};
      transform: translateX(-0.05em);
    }
    .line-0 {
      transform: translateX(-13%);
    }
    background-color: ${color.red};
  `
  return (
    <Holder>
      <Parts className="parts">
        <Text className="line-0">
          {Split("It")}
          <b> </b>
          {Split("is")}
          <b> </b>
          {Split("not")}
        </Text>
        <Text className="line-1">{Split("About")}</Text>
        <Text className="yellow line-2">
          <Q className="q">
            <Figure className="figure">Q</Figure>
          </Q>
          {Split("uantity")}
        </Text>
        <Text className="line-3">
          {Split("it")}
          <b> </b>
          {Split("is")}
        </Text>
        <Text className="line-4">{Split("about")}</Text>
      </Parts>
      <Uality className="uality">
        <Figure className="figure">Uality</Figure>
      </Uality>
    </Holder>
  )
}

export default Quality
